import APIController from '../core-api-controller';

export const fetchChatProfiles = (userId = '', params = '') => {
  const path = `${APIController.endpointApi}/client_user/users/${userId}/fetch_crm_conversation${params ? params : ''}`;
  return APIController.getApiCallback(path);
};

export const fetchChatConversations = (params = '') => {
  const path = `${APIController.endpointApi}/conversations${params ? params : ''}`;
  return APIController.getApiCallback(path);
};

export const sendCrmMessage = (userId, data = {}) => {
  const path = `${APIController.endpointApi}/users/${userId}/send_crm_message`;
  return APIController.postCallback(path, data);
};

export const markMessagesRead = (conversation_id) => {
  const path = `${APIController.endpointApi}/users/mark_messages_as_read?conversation_id=${conversation_id}`;
  return APIController.postCallback(path);
};

export const getConversationMessages = ({ id = '', params = {} }) => {
  const path = `${APIController.endpointApi}/conversations/${id}/messages`;
  return APIController.getApiCallback(path, params);
};

export const getLeadConversationApi = (leadId = '') => {
  const path = `${APIController.endpointApi}/leads/${leadId}/crm_conversation`;
  return APIController.getApiCallback(path);
};
